import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import CityDrinksStepData from '~/company/configs/citydrinks/onboarding';
import DefaultStepData from '~/company/configs/default/onboarding';
import { CompanyName } from '~/company/interface';
import Modal from '~/components/Modal/Modal';
import { useGlobal } from '~/hooks/useGlobal';
import { useModal } from '~/hooks/useModal';

import { userStore } from '~/stores';

export default observer(() => {
  const { t } = useTranslation();
  const { isMobile } = useGlobal();
  const { closeModal } = useModal();

  const handleEnter = () => {
    userStore.setIsAdult(true);
    closeModal();
  };

  const STEPS_DATA = company.variant({
    '1': CityDrinksStepData(),
    '2': DefaultStepData(),
  });

  useEffect(() => {
    STEPS_DATA.stepsData.forEach((step) => {
      const img = new Image();
      img.src = step.img;
    });
  }, [STEPS_DATA]);

  const logo = company.images.ageRestriction[isMobile ? 'white' : 'color'];

  return (
    <Modal
      isShow
      className="_mobile-fullscreen modal-age-restricted__body"
      containerClassName="modal-age-restricted__container"
    >
      <div data-company={company.name} className="modal-age-restricted">
        <img className="modal-age-restricted__logo" src={logo} alt="" />
        <div className="modal-age-restricted__text">
          {t(
            company.name === CompanyName.Heimkaup
              ? 'phrases:ageRestrictionHeimkaup'
              : 'phrases:ageRestriction',
            {
              age: company.config.ageRestricted
                ? company.config.ageRestricted
                : 21,
            },
          )}
        </div>
        <div className="modal-age-restricted__text">
          <Trans
            i18nKey={
              company.name === CompanyName.Heimkaup
                ? 'phrases:byEnteringConfirmAgeHeimkaup'
                : 'phrases:byEnteringConfirmAge'
            }
            components={{
              a: (
                <a
                  href={
                    (company.name === CompanyName.Heimkaup
                      ? company.config.links.legals?.paymentAndDeliveryPolicy
                          ?.link
                      : company.config.links.legals?.generalTradingPolicy
                          ?.link) || '/'
                  }
                />
              ),
            }}
          />
        </div>
        <button
          className="button _primary _med _block modal-age-restricted__btn-enter"
          onClick={handleEnter}
        >
          {t('enter')}
        </button>
      </div>
    </Modal>
  );
});
